<template>
  <div class="home">
    <div class="card mt-3">
      <header class="card-header">
        <p class="card-header-title has-background-info-light has-text-info-dark">
          Od {{ since + 'T10:00:00.000Z' | moment('Do MMMM YYYY.') }}
          ({{ since + 'T10:00:00.000Z' | moment('from', 'now') }})
        </p>
      </header>
      <div class="card-content">
        <div class="table-container">
          <table
            class="table is-bordered is-striped
        is-narrow is-hoverable is-fullwidth"
          >
            <thead>
              <tr>
                <th>Ime</th>
                <th>CW</th>
                <th>Ostalo</th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <th>Ime</th>
                <th>CW</th>
                <th>Ostalo</th>
              </tr>
            </tfoot>
            <tbody>
              <tr v-for="st in stats" :key="st._id">
                <td>
                  <router-link :to="'/member/' + st._id.substring(1)">{{ st.name }}</router-link>
                </td>
                <td>{{ st.cw }}</td>
                <td>{{ st.other }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import moment from 'moment';

moment.locales('hr');

export default {
  setup() {
    const apiHost = process.env.VUE_APP_API_HOST;
    const cwStatsURL = '/clan/cw/month';

    const stats = ref([]);
    const tjedni = moment().isoWeekday('Sunday').days('-28').format('YYYY-MM-DD');
    const since = tjedni;

    const API_URL = apiHost;

    async function getStats() {
      const response = await fetch(API_URL + cwStatsURL);
      const json = await response.json();
      stats.value = json;
    }

    getStats();

    return {
      stats,
      since,
    };
  },
};
</script>
